<template lang="html">
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>

      <v-flex xs12>
        <v-layout row wrap>

          <!-- Title -->
          <v-flex xs12>
            <v-text-field
            v-model="page.title"
            :error-messages="titleErrors"
            label="Título"
            required
            @input="$v.page.title.$touch()"
            @blur="$v.page.title.$touch()"
            ></v-text-field>
          </v-flex>

          <!-- URL -->
          <v-flex xs12>
            <v-text-field
            prefix="www.respirardeouvido.com/"
            v-model="page.urlSlug"
            label="URL"
            required
            ></v-text-field>
          </v-flex>

        </v-layout>
      </v-flex>

    </v-layout>

    <!-- <v-layout row wrap> -->
    <v-flex xs12>
      <vue-editor v-model="page.body" />
    </v-flex>

  </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    value:{
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      showDatePicker: false,
      cleanDescription: {
        title: null,
        sub_title: null,
        content: null,
        type: 0,
        image: null,
      }
    }
  },
  validations: {
    page:{
      title: {
        required
      },
      body: {
        required
      }
    },
  },
  computed: {
    page:{
      get: function (){
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    },
    titleErrors () {
      const errors = []
      if (!this.$v.page.title.$dirty) return errors
      !this.$v.page.title.required && errors.push('Título é obrigatório.')
      return errors
    }
  },
  methods: {
    convertToSlug: function (Text) {
      return Text
          .toLowerCase()
          .replace(/ /g,'-')
          .replace(/[^\w-]+/g,'')
          ;
    },
    slugChanged: function() {
      this.page.urlSlug = this.convertToSlug(this.page.urlSlug)
    }
  },
  components:{
  },
  watch:{
    page:{
      deep: true,
      handler: function (val) {
        this.$emit('change', {
          page: val,
          valid: !this.$v.$invalid
        })
      }
    },
    "page.urlSlug":{
      handler: function (val) {
        this.page.urlSlug = this.convertToSlug(val)
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
